import WorthyApi from 'lib/api/worthyApi';
import rootStore from 'reducers';
import { ado } from 'actions/ado';
import { session } from 'actions/session';
import { showLoader, hideLoader } from 'actions/loader';
import { Authenticator } from 'lib/api/authenticator'

export const PERFORM_LOGIN = Symbol('PERFORM_LOGIN');

export function performLoginWithMonolith(loginFunc, bundle_id) {
    // Perform two-stage login:
    // first we call the loginFunc to login to authenticator,
    // then we send "login" request  to the monolith
    // The monolith performs whatever magic it does, icluding
    // picking up the item that the client has just submitted
    // and attaching it to the user.
    // bundle_id parameter will be undefined if the item was not submitted
    // through the worthy-app

    rootStore.dispatch(showLoader());
    // WORTHY-12509 - support authentication service.
    // We need to authenticate the user before we send the login
    // request to the monolith. We still need to send the login
    // request to the monolith since it performs some operations and retrieves
    // state.
    const promise = new Promise((resolve, reject) => {
        // shared rejection functionion for reuse
        const rejected = (err) => {
            rootStore.dispatch(session(null));
            rootStore.dispatch(hideLoader());
            reject(err)
        }
        // user can either login with email && password or with one time password
        // The call to the authenticator - if successful, will eventually
        // resolve to the response of the call to the monolith.
        loginFunc().then(() => {
            WorthyApi.logIn({ bundle_id: bundle_id }).then((response) => {
                rootStore.dispatch(session(response.data.user));
                rootStore.dispatch(hideLoader());
                setTimeout(() => {
                    rootStore.dispatch(ado());
                }, 2000);
                resolve(response);
            }).catch(rejected)
        }).catch(rejected)
    })

    return {
        type: PERFORM_LOGIN,
        payload: promise
    }
}

export function performLogIn(params) {
    let loginFunc
    // is this a user / password login or otp code login?
    if (params.email && params.password) {
        loginFunc = Authenticator.login.bind(null, params.email, params.password)
    } else if (typeof params.otp_code !== 'undefined') {
        loginFunc = Authenticator.otpLogin.bind(null, params.email, params.otp_code, params.medium, params.request_id)
    } else {
        throw new Error('Invalid parameter set for login ' + JSON.stringify(params))
    }

    return performLoginWithMonolith(loginFunc, params.bundle_id);
}

export function sendCode(params) {
    if (!params.request_id) rootStore.dispatch(showLoader());
    let request = Authenticator.oneTimePassword(params.email, params.medium).then((response)=>{
        rootStore.dispatch(hideLoader());
        return response;
    }).catch((error)=>{
        rootStore.dispatch(hideLoader());
        throw error;
    });

    return {
        type:       null,
        payload:    request
    }
}
